import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface DialogConfirmCopyOrderProps {
  open: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 440,
        width: "100%",
        borderRadius: 16
      },
      "& .MuiDialogTitle-root": {
        padding: 24
      },
      "& .MuiDialogContent-root": {
        paddingTop: 5
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24,
        columnGap: 16
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem"
      }
    },
    btnAction: {
      height: 48
    }
  }),
  { name: "DialogConfirmOrder" }
);

const DialogConfirmCopyOrder: React.FC<DialogConfirmCopyOrderProps> = ({
  open,
  loading = false,
  onConfirm,
  onClose
}) => {
  const intl = useIntl();
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.root}
      disableScrollLock={true}
      data-testid="dialogConfirmCopyOrder"
    >
      <DialogTitle>
        <MyTypography variant={"h6"} style={{ color: "#009FB8" }}>
          {intl.formatMessage({ defaultMessage: "ยืนยัน Copy Order" })}
        </MyTypography>
      </DialogTitle>
      <DialogContent>
        <MyTypography variant={"body2"}>
          {intl.formatMessage({
            defaultMessage:
              'กรุณากด "ยืนยัน" เพื่อ Copy ข้อมูล > สร้างคำสั่งซื้อใหม่ หรือกด "กลับไป" เพื่อปิดหน้าต่าง'
          })}
        </MyTypography>
      </DialogContent>
      <DialogActions disableSpacing={true}>
        <Button
          id="backButton"
          data-testid="backButton"
          color={"secondary"}
          disabled={loading}
          variant={"outlined"}
          className={classes.btnAction}
          fullWidth={true}
          onClick={onClose}
        >
          <FormattedMessage defaultMessage={"กลับไป"} />
        </Button>
        <Button
          id="confirmButton"
          data-testid="confirmButton"
          color={"secondary"}
          disabled={loading}
          variant={"contained"}
          className={classes.btnAction}
          fullWidth={true}
          onClick={onConfirm}
        >
          <FormattedMessage defaultMessage={"ยืนยัน"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmCopyOrder;
